import { AUTHENTICATE_USER, LOGOUT } from "../actions/actionTypes";

const initialState = {
    loggedUser: null,
    isAuthenticated: false
};

export const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case AUTHENTICATE_USER:
            return {
                ...state,
                loggedUser: action.user,
                isAuthenticated: true
            }
        case LOGOUT:
            return {
                ...state,
                loggedUser: null,
                isAuthenticated: false
            }
        default:
            return state;
    }
};